import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useI18next } from "gatsby-plugin-react-i18next";
import React, { useEffect, useState } from "react";
import Layout from "../corporate-site/layout";
import { newCustomerSetPassword, resendSMSOTP } from "../qnb/api/login";
import { saveQuoteToUser } from "../qnb/api/quotation";
import OTP from "../qnb/components/Popup/Login/otp";
import ResetPassword from "../qnb/components/Popup/Login/resetPassword";
import { loadTencentCaptcha } from "../shared/utils/tencent_captcha";
export var activeAccountSource = "active-acc";
var Verify = function Verify() { var _useState = useState(""), next = _useState[0], setNext = _useState[1]; var _useState2 = useState(""), tokenId = _useState2[0], setTokenId = _useState2[1]; var _useI18next = useI18next(), language = _useI18next.language; useEffect(function () { var abortController = new AbortController(); var urlParams = new URLSearchParams(window.location.search); setNext(urlParams.get("next")); setTokenId(urlParams.get("tokenID")); return function () { abortController.abort(); }; }, []); var _useState3 = useState(""), extErrorCode = _useState3[0], setExtErrorCode = _useState3[1]; var _useState4 = useState(""), password = _useState4[0], setPassword = _useState4[1]; var i18n = useI18next(); var onSubmitOTP = /*#__PURE__*/ function () { var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(otpValue) { var _res$data, _res$data2; var res, apiSaveQuoteToUserRequest, _res$data$referUrl; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return newCustomerSetPassword({ otpCode: otpValue ? otpValue.join("") : "", pwdMD5: password, gbdToken: tokenId });
        case 2:
            res = _context.sent;
            if (!(res.data != null && ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.productCode) != null && ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.quoteNo) != null)) {
                _context.next = 7;
                break;
            }
            apiSaveQuoteToUserRequest = { productCode: res.data.productCode, quoteNo: res.data.quoteNo };
            _context.next = 7;
            return saveQuoteToUser(apiSaveQuoteToUserRequest);
        case 7: if (!res.errorCode && res.result) {
            i18n.navigate((_res$data$referUrl = res.data.referUrl) !== null && _res$data$referUrl !== void 0 ? _res$data$referUrl : "/");
        }
        else {
            setExtErrorCode(res.errorCode);
        }
        case 8:
        case "end": return _context.stop();
    }
} }, _callee); })); return function onSubmitOTP(_x) { return _ref.apply(this, arguments); }; }(); var onSubmitResetPW = /*#__PURE__*/ function () { var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(password) { var data, res; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            _context2.next = 2;
            return loadTencentCaptcha(language);
        case 2:
            data = _context2.sent;
            if (!(data && Object.keys(data).length !== 0)) {
                _context2.next = 10;
                break;
            }
            _context2.next = 6;
            return resendSMSOTP(data.ticket, data.randstr);
        case 6:
            res = _context2.sent;
            if (!res.errorCode && res.result) {
                setPassword(password);
                setNext("otp");
            }
            _context2.next = 11;
            break;
        case 10: setExtErrorCode("-612");
        case 11:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return function onSubmitResetPW(_x2) { return _ref2.apply(this, arguments); }; }(); return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement("div", { className: "bg-msg-1 py-10 lg:py-24 px-4 lg:px-10" }, next === "pw" && /*#__PURE__*/ React.createElement(ResetPassword, { onSubmit: onSubmitResetPW }), next === "otp" && /*#__PURE__*/ React.createElement(OTP, { onSubmit: onSubmitOTP, extErrorCode: extErrorCode, source: activeAccountSource }))); };
export default Verify;
var query = "3698718234";
